import type { AsyncData } from "#app";
import type { NitroFetchOptions } from "nitropack";
import type { UseApiFetchOptions } from "@edco/apollo/dist/runtime/composables/useApiFetch";
import type { ContentItem } from "@edco/apollo";

export type LinkType = "internal" | "external" | "media";

export type Udi = {
  guid: string;
  entityType: string;
};

export type UmbracoLink = {
  name?: string;
  target?: string;
  type: LinkType;
  udi?: Udi;
  content?: Record<string, any>; // Assuming that content can have various properties
  url?: string;
};

export type MenuItemDto = {
  label: string;
  url: string;
};

export type NavLinkDto = {
  label: string;
  url: string;
  target?: string;
};

export type LayoutDataDto = {
  discoverThemes: MenuItemDto[];
  quickLinks: NavLinkDto[];
  quickLinksHeading?: string;
  mainNavigationLinks: NavLinkDto[];
  loggedInMainNavigationLinks: NavLinkDto[];
  showCpdLink: boolean;
  subscriberCpdLink: NavLinkDto | null;
  nonSubscriberCpdLink: NavLinkDto | null;
  nonSubscriberJoinButton: boolean;
  logoLinkText?: string;
  skipLinkText?: string;
  footerHeading?: string;
  footerDescription?: string;
  socialLinksHeading?: string;
  addressLines: string[];
  linkedInUrl?: string;
  twitterUrl?: string;
  copyrightNotice?: string;
  hasAcceptedGuidelines: boolean;
  guidelines: ContentItem;
};

export function $layoutResource() {
  const dependencies = useFetchDependencies();

  function getLayoutData(abortSignal?: AbortSignal) {
    const url = "/api/isn/layout";
    const options: NitroFetchOptions<string> = {
      method: "GET",
      signal: abortSignal,
      headers: {
        Accept: "application/json",
      },
    };

    return $apiFetch<LayoutDataDto>(url, options, dependencies);
  }

  return {
    getLayoutData,
  };
}

export function useLayoutResource() {
  function getLayoutData(): AsyncData<LayoutDataDto, Error | null> {
    const url = "/api/isn/layout";
    const options: UseApiFetchOptions<LayoutDataDto> = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return useApiFetch<LayoutDataDto>(url, options);
  }

  return {
    getLayoutData,
  };
}
